import React, { useState, useEffect, useContext } from "react";
// @mui material components
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import Switch from "@mui/material/Switch";
import Icon from "@mui/material/Icon";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Cookies from "js-cookie";
// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg.jpg";

import { axiosInstance } from "../../../axios";
import useAuth from "../../../hooks/useAuth";
import AuthContext from "../../../store/auth-context";
import axios from "axios";
import useUser from "../../../hooks/useUser";
import { useMaterialUIController } from "context";
import { setAnotherPage } from "context";
import { setHomePage } from "context";
import LoginIcon from "@mui/icons-material/Login";
import MobileFriendlyIcon from "@mui/icons-material/MobileFriendly";
function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const { setAccessToken, setCSRFToken, accessToken } = useAuth();
  const { setStatusAuth, setUser } = useContext(AuthContext);
  const [imgQR, setImgQR] = useState(null);

  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({
    password: "",
    username: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOTP] = useState(null);
  const [showOtp, setShowOTP] = useState(null);
  const [values, setValues] = useState({
    showPass: false,
  });
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
    setAnotherPage(dispatch, false);
  }, []);
  function onUsernameChange(event) {
    setUsername(event.target.value);
  }

  function onPasswordChange(event) {
    setPassword(event.target.value);
  }

  function onOTPChange(event) {
    setOTP(event.target.value);
  }
  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = {};
    _data["password"] = password;
    _data["username"] = username;
    if (otp) {
      _data["OTP"] = otp;
    }
    _data["username"] = username;
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    try {
      const response = await axiosInstance.post("login", _data);
      if (response.data.qr_code) {
        setImgQR(`data:image/png;base64,${response.data.qr_code}`);
        return 0;
      } else if (response.data.otp) {
        setShowOTP(true);
      } else {
        let refreshToken = response?.data?.refresh_token;
        setAccessToken(response?.data?.access_token);
        setCSRFToken(response.headers["x-csrftoken"]);
        setUsername(username);
        setPassword(password);
        setStatusAuth("login");
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 1); // Add 1 day
        getUser();
        if (rememberMe) {
          Cookies.set(
            "rememberedUser",
            JSON.stringify({ username, password, rememberMe }),
            {
              expires: expirationDate,
            }
          );
        } else Cookies.remove("rememberedUser");
        navigate("/dashboard", {
          state: { successMessage: "Đăng nhập thành công!" },
        });
      }
    } catch (error) {
      if (error.response) {
        setError(error.response.data);
      } else if (error.message) {
        setError(error.message);
      } else {
        setError("Lỗi đăng nhập! Chưa xác định. Liên hệ admin.");
      }
    }
  }
  useEffect(() => {
    const rememberedUser = Cookies.get("rememberedUser");
    if (rememberedUser) {
      const { username, password, rememberMe } = JSON.parse(rememberedUser);
      setUsername(username);
      setPassword(password);
      setRememberMe(rememberMe);
    }
    if (accessToken) {
      navigate("/dashboard");
    }
  }, []);

  const handlePassVisibilty = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Đăng nhập
          </MDTypography>
        </MDBox>
        <MDBox pt={2} px={3}>
          {error && <Alert severity="error">{error}</Alert>}
        </MDBox>
        <MDBox pt={3} pb={3} px={3}>
          <MDBox component="form" role="form">
            {!imgQR && !showOtp && (
              <>
                <MDBox mb={2}>
                  <TextField
                    type="text"
                    name="username"
                    label="Username"
                    fullWidth
                    required
                    // disabled={imgQR ? true : false}
                    autoFocus
                    defaultValue={username}
                    onChange={onUsernameChange}
                    error={errors ? !!errors.username : false}
                    helperText={errors?.username}
                    onFocus={() => {
                      setErrors({
                        ...errors,
                        username: "",
                      });
                    }}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <TextField
                    type={values.showPass ? "text" : "password"}
                    name="password"
                    label="Password"
                    // disabled={imgQR ? true : false}
                    fullWidth
                    required
                    defaultValue={password}
                    onChange={onPasswordChange}
                    error={errors ? !!errors.password : false}
                    helperText={errors?.password}
                    onFocus={() => {
                      setErrors({
                        ...errors,
                        password: "",
                      });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handlePassVisibilty}
                            aria-label="toggle password"
                            edge="end"
                          >
                            {values.showPass ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </MDBox>
                <MDBox display="flex" alignItems="center" ml={-1}>
                  <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    onClick={handleSetRememberMe}
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Nhớ tài khoản
                  </MDTypography>
                </MDBox>
              </>
            )}

            {(imgQR || showOtp) && (
              <MDBox
                // m={2}
                display="flex"
                flexDirection="column"
                alignItems="center" // Căn giữa theo chiều ngang
                justifyContent="center" // Căn giữa theo chiều dọc nếu cần
                height="100%" // Tùy chọn: Đặt chiều cao của MDBox nếu cần
              >
                {imgQR && (
                  <>
                    <img width="50%" src={imgQR} alt="QR Code" />
                    <p style={{ fontSize: "10px", paddingBottom: "15px" }}>
                      Quét mã QR bằng ứng dụng Google Authenticator để lấy mã
                      OTP
                    </p>
                  </>
                )}
                {showOtp && (
                  <p style={{ fontSize: "10px", paddingBottom: "15px" }}>
                    Mở ứng dụng Google Authenticator để lấy mã OTP
                  </p>
                )}
                <TextField
                  type="text"
                  name="OTP"
                  label="Nhập mã OTP"
                  fullWidth
                  required
                  onChange={onOTPChange}
                />
              </MDBox>
            )}
            <MDBox mt={3} mb={1}>
              <Button
                fullWidth
                type="submit"
                onClick={onSubmitForm}
                variant="contained"
                startIcon={!showOtp ? <LoginIcon /> : <MobileFriendlyIcon />}
                sx={{ color: "#ffffff" }}
                disabled={showOtp && otp?.length != 6}
              >
                {!showOtp ? `Đăng nhập` : `Xác nhận mã`}
              </Button>
              {/* <MDButton
                variant="gradient"
                color="info"
                fullWidth
                type="submit"
                onClick={onSubmitForm}
                disable={true}
              >
                <Icon sx={{ fontWeight: "bold" }}>login</Icon>
                
              </MDButton> */}
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Bạn quên mật khẩu?{" "}
                <MDTypography
                  component={Link}
                  to="/reset-password"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Quên mật khẩu
                </MDTypography>
              </MDTypography>
            </MDBox>
            <MDBox textAlign="center">
              <MDTypography variant="button" color="text">
                <MDTypography
                  component={Link}
                  to="/"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Quay lại Trang chủ
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

const validateRequired = (value) => !!value.length;

function validateOBJ(user) {
  return {
    username: !validateRequired(user.username)
      ? "Tài khoản người dùng không được trống"
      : "",
    password: !validateRequired(user.password)
      ? "Mật khẩu không được trống"
      : "",
  };
}

export default Basic;
